/* ODDFISH HOME SERVICES — upload to Theme > Assets as home-services.js */
(function () {
  "use strict";

  function initServices(root) {
    var buttons = root.querySelectorAll(".of-svc-btn");
    if (!buttons.length) return;

    /* Avoid double-binding in theme editor */
    if (root.dataset.ofSvcBound === "1") return;
    root.dataset.ofSvcBound = "1";

    var openBtn = null;

    function closeAll() {
      buttons.forEach(function (btn) {
        btn.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
        var sub = btn.parentElement.querySelector(".of-svc-sub");
        if (sub) sub.hidden = true;
      });
      openBtn = null;
    }

    buttons.forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (openBtn === btn) {
          closeAll();
          return;
        }

        closeAll();
        btn.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        var sub = btn.parentElement.querySelector(".of-svc-sub");
        if (sub) sub.hidden = false;
        openBtn = btn;
      });
    });
  }

  function boot() {
    document.querySelectorAll("#oddfish-home-services-root").forEach(function (root) {
      root.dataset.ofSvcBound = "0";
      initServices(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:unload", function (e) {
    var root = e.target.querySelector("#oddfish-home-services-root");
    if (root) root.dataset.ofSvcBound = "0";
  });
})();
